import { BaSeLoadingPage } from '@base/react';
import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';
import { controlPanelRoutes } from './modules/control-panel/routes';
import { dashboardRoutes } from './modules/dashboard/routes';
import { screeningRoutes } from './modules/screening/routes';
import { classificationRoutes } from './modules/classification/routes';
import { entryRoutes } from './modules/entry/routes';
import { AppContainer } from './modules/main/containers/app-container';
import { mainRoutes } from './modules/main/routes';
import { publicRoutes } from './modules/public/routes';
import ForbiddenPage from './modules/main/pages/forbidden-page';
import { evaluationPanelRoutes } from './modules/evaluation-panel/routes';

const createRoute = (route: Sebrae.RouteConfig) => ({
  ...route,
  isExactPath: true,
  pageToRender: (
    <React.Suspense fallback={<BaSeLoadingPage />}>
      <AppContainer>{route.pageToRender}</AppContainer>
    </React.Suspense>
  ),
  orRedirectTo:
    typeof route.orRedirectTo === 'string' ? (
      route.orRedirectTo
    ) : route.orRedirectTo ? (
      <React.Suspense fallback={<BaSeLoadingPage />}>
        {route.orRedirectTo}
      </React.Suspense>
    ) : (
      <ForbiddenPage />
    ),
});

export const Routes = () => (
  <Sebrae.Routes
    routes={[
      ...mainRoutes.map((route: Sebrae.RouteConfig) => createRoute(route)),
      ...publicRoutes.map((route: Sebrae.RouteConfig) => createRoute(route)),
      ...entryRoutes.map((route: Sebrae.RouteConfig) => createRoute(route)),
      ...dashboardRoutes.map((route: Sebrae.RouteConfig) => createRoute(route)),
      ...screeningRoutes.map((route: Sebrae.RouteConfig) => createRoute(route)),
      ...classificationRoutes.map((route: Sebrae.RouteConfig) =>
        createRoute(route),
      ),
      ...controlPanelRoutes.map((route: Sebrae.RouteConfig) =>
        createRoute(route),
      ),
      ...evaluationPanelRoutes.map((route: Sebrae.RouteConfig) =>
        createRoute(route),
      ),
    ]}
  />
);
